import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";

export class ServiceValidationsTemplatesTableRowComponent implements IController {

  template: any;
  canEdit: boolean;
  canDelete: boolean;
  canReset: boolean;
  settingsValue: any;
  form: any;
  onEdit: Function;
  onDelete: Function;
  onReset: Function;
  onSettingsValueChange: Function;
  onChangeEnabledPurposes: Function;

  public enabledPurposesMap = {};
  public taskPurposeTypes: typeof TaskPurposeType = TaskPurposeType;

  $onChanges(changes: IOnChangesObject) {
    if (changes.template || changes.settingsValue) {
      this.enabledPurposesMap = {};
      if (this.settingsValue?.value?.enabledTaskPurpose) {
        this.settingsValue?.value?.enabledTaskPurpose?.forEach((ep) => {
          this.enabledPurposesMap[ep] = true;
        })
      } else if (this.settingsValue?.parentValue?.enabledTaskPurpose) {
        this.settingsValue?.parentValue?.enabledTaskPurpose?.forEach((ep) => {
          this.enabledPurposesMap[ep] = true;
        })
      }
    }
  };

  toggleEnabledPurpose(purpose: TaskPurposeType) {
    if (!this.settingsValue.value) {
      this.settingsValue.value = {};
    }
    if (!this.settingsValue.value?.enabledTaskPurpose) {
      this.settingsValue.value.enabledTaskPurpose = this.settingsValue.parentValue?.enabledTaskPurpose || [];
    }

    if (!this.enabledPurposesMap[purpose]) {
      const purposeIndex = this.settingsValue.value.enabledTaskPurpose.findIndex(p => p === purpose);
      this.settingsValue.value.enabledTaskPurpose.splice(purposeIndex, 1);
    } else {
      this.settingsValue.value.enabledTaskPurpose.push(purpose);
    }

    this.onChangeEnabledPurposes({enabledPurpose: this.settingsValue.value.enabledTaskPurpose});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('serviceValidationsTemplateTableRow', {
    bindings: {
      template: '<',
      canEdit: '<?',
      canDelete: '<?',
      canReset: '<?',
      settingsValue: '<?',
      onEdit: '&',
      onDelete: '&',
      onReset: '&',
      onSettingsValueChange: '&',
      onChangeEnabledPurposes: '&'
    },
    template: require('./service-validations-templates-table-row.html').default,
    controller: ServiceValidationsTemplatesTableRowComponent
  });
